import $ from "jquery";
import slick from "slick-carousel";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		let $slides = $( '.slides' );
		$slides.each(
			function () {
				if ( $slides.length ) {
					let args = {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: false,
						arrows: false,
						infinite: true,
						autoplay: true,
						autoplaySpeed: ( $slides.data( 'speed' ) ) ? $slides.data( 'speed' ) : 7000,
						responsive: [],
					
					}
					$( this ).slick( args );
				}
			}
		);
	}
);
